var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h2',[_vm._v("Endereço de Envio")]),_c('ErroNotificacao',{attrs:{"erros":_vm.erros}}),_c('UsuarioForm',[_c('button',{staticClass:"btn btn-checkout",on:{"click":function($event){$event.preventDefault();return _vm.finalizarCompra.apply(null, arguments)}}},[_vm._v("Finalizar Compra")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }